<ds-accordion style="margin-top: 1%">
  <ds-accordion-item>
    Authorized Drivers
    <div content>
      <div style="height: 400px; display: flex">
        <ds-box style="flex: 1">
          <ds-box-header
            >Driver License Information (as it appears in state issued driver
            license)</ds-box-header
          >
          <ds-box-content>Employee Form</ds-box-content>
          <ds-box-footer class="d-flex justify-content-between">
            <button
              ds-button
              aria-label="Email Consent to Authorized Driver"
              (click)="handleSendConsentEmail()"
            >
              EMAIL CONSENT
            </button>
            <button
              ds-button
              aria-label="Delete Authorized Driver"
              (click)="handleDeleteAuthorizedDriver()"
            >
              DELETE AUTHORIZED DRIVER
            </button></ds-box-footer
          >
        </ds-box>
      </div>
      <button
        style="margin-top: 1%"
        ds-button
        aria-label="Add Authorized Driver"
        (click)="handleAddAuthorizedDriver()"
      >
        ADD AUTHORIZED DRIVER
      </button>
    </div>
  </ds-accordion-item>
</ds-accordion>
